import { render, staticRenderFns } from "./historical.vue?vue&type=template&id=2628de20"
import script from "./historical.vue?vue&type=script&lang=js"
export * from "./historical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports